<template lang="html">

  <section class="app">
    <src-components-header v-if="showHeader"></src-components-header>
    <src-components-main v-on:refresh-header="refreshHeader()"></src-components-main>
  </section>

</template>

<script lang="js">
  import SrcComponentsHeader from './Header';
  import SrcComponentsMain from './Main';
  export default  {
    name: 'app',
    components: { SrcComponentsMain, SrcComponentsHeader },
    props: [],
    mounted() {

    },
    data() {
      return {
        showHeader: true
      }
    },
    methods: {
      refreshHeader() {
        this.showHeader = false;
        this.$nextTick(() => {
          this.showHeader = true;
        })
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .app {

  }
</style>
